import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  TYPE_STUDIO,
  TYPE_PREP,
  TYPE_SET,
  TYPE_RETOUCH,
  TYPE_MERCHANDISE_COORDINATION,
  TYPE_PLANNING_PRODUCING,
  TYPE_INVENTORY_PREP,
  TYPE_ASSISTANT_TEAM,
} from '../../constants/booking';
import StudioSheet from './LocationSheets/StudioSheet';
import StylingRoomSheet from './LocationSheets/StylingRoomSheet';
import AccessoriesSheet from './LocationSheets/AccessoriesSheet';
import MerchandiseSheet from './LocationSheets/MerchandiseSheet';
import PlanningSheet from './LocationSheets/PlanningSheet';
import GeneralLocationSheet from './LocationSheets/GeneralLocationSheet';
import { renderSheets } from './CallsheetUtils';
import CallsheetHeader from './CallsheetHeader';
import { naturalSortKeys } from '../../helpers/callSheetHelpers';

import i18n from '../../i18n';

class VisualProductionCallsheet extends Component {
  render() {
    const { bookings, date, renderForEmail, locationContacts } = this.props;
    
    let locationSheets = [];

    Object.entries(bookings).forEach(locationTypeEntry => {
      const [locationTypeIdString, locations] = locationTypeEntry;
      const locationTypeId = parseInt(locationTypeIdString, 10);
      const filteredLocationContacts = locationContacts ? locationContacts[locationTypeId] : i18n.t('noData');

      switch (locationTypeId) {
        case TYPE_STUDIO:
          locationSheets = locationSheets.concat(
            renderSheets(
              StudioSheet,
              locations,
              renderForEmail,
              locationContacts
            )
          );
          break;
        case TYPE_PREP:
          locationSheets = locationSheets.concat(
            renderSheets(
              StylingRoomSheet,
              locations,
              renderForEmail,
              locationContacts
            )
          );
          break;
        case TYPE_SET:
          locationSheets = locationSheets.concat(
            renderSheets(
              AccessoriesSheet,
              locations,
              renderForEmail,
              locationContacts
            )
          );
          break;
        case TYPE_RETOUCH:
        case TYPE_INVENTORY_PREP:
        case TYPE_ASSISTANT_TEAM:
          locationSheets = locationSheets.concat(
            renderSheets(
              GeneralLocationSheet,
              locations,
              renderForEmail,
              filteredLocationContacts
            )
          );
          break;
        case TYPE_MERCHANDISE_COORDINATION:
          locationSheets = locationSheets.concat(
            renderSheets(MerchandiseSheet, locations, renderForEmail, null)
          );
          break;
        case TYPE_PLANNING_PRODUCING:
          locationSheets = locationSheets.concat(
            renderSheets(PlanningSheet, locations, renderForEmail, null)
          );
          break;
        default:
          // Skip over location types that don't pertain to this callsheet
          break;
      }
    });

    return (
      <>
        <CallsheetHeader date={date} renderForEmail={renderForEmail} />
        {locationSheets.sort(naturalSortKeys)}
      </>
    );
  }
}

VisualProductionCallsheet.propTypes = {
  bookings: PropTypes.objectOf(PropTypes.objectOf(PropTypes.object)).isRequired,
  date: PropTypes.instanceOf(Date).isRequired,
  renderForEmail: PropTypes.bool.isRequired,
  locationContacts: PropTypes.objectOf(
    PropTypes.oneOfType([PropTypes.string, PropTypes.array])
  ).isRequired
};

export default VisualProductionCallsheet;
